import { useMutation, useQuery } from '@tanstack/react-query';
import { apiGet, apiPost } from '@/api/client';

interface HealthResponse {
  status: string;
  version?: string;
}

// Healthz lives at the ROOT of the admin server (`/healthz`), NOT under
// `/admin/v1` — see `backend/internal/router/admin.go:24`. The shared
// axios client has `baseURL = ${VITE_API_URL}/admin/v1`, so for this
// single call we override `baseURL` per-request to point at the API host
// root. This is the ONLY call in the SPA that needs to escape
// `/admin/v1`; we keep using the same axios instance (no new client).
const HEALTHZ_BASE = `${import.meta.env.VITE_API_URL ?? ''}`;

export function useHealth() {
  return useQuery({
    queryKey: ['admin', 'health'],
    queryFn: () =>
      apiGet<HealthResponse>('/healthz', { baseURL: HEALTHZ_BASE }),
    refetchInterval: 30_000,
    retry: false,
  });
}

export function useRecomputeAllScoresSystem() {
  return useMutation({
    mutationFn: () => apiPost<void>('/system/recompute-all-scores'),
  });
}
